const STORES_DE =
  ",063,066,069,075,092,102,117,118,119,124,129,139,146,147,148,174,184,187,221,222,223,224,225,226,227,228,229,245,289,320,321,322,323,324,325,326,328,332,333,343,369,393,394,396,397,412,421,425,430,492,493,494,520,521,617#Potsdam,";
const STORES_DK = ",005,094,121,172,298,591,";
const STORES_AT = ",085,090,155,273,386,387,388,587,";
const OLD_PRIVACY_LIMIT = STORES_AT + STORES_DE + STORES_DK;

const isShortLimit = ({ store_id }) => OLD_PRIVACY_LIMIT.includes(store_id);

module.exports.isShortLimit = isShortLimit;
